import { useQuery } from '@tanstack/react-query'
import { api } from '../../lib/api.ts'

/** Mirrors `GET /api/me/today` (apps/api/src/services/ayat.ts). */
export type AyatSummary = {
  day: number
  surah: number
  ayatFrom: number
  ayatTo: number
  /** "QS. Al-Insyirah: 5–6" */
  ref: string
  tema: string | null
  /** null until the licensed Qur'an dataset is installed on the server: show the reference only */
  ar: string | null
  terjemah: string | null
  reviewed: boolean
}

/** `light`: total points ("cahaya"); `level`: garden level 1..5. */
export type Stats = { streak: number; bestStreak: number; totalAyat: number; totalWords: number; stones: number; etape: number; light: number; level: number }

export type Today = {
  ok: true
  today: string
  day: number
  done: boolean
  ayat: AyatSummary | null
  finishedAll: boolean
  journal: { text: string; amalanDone: boolean } | null
  stats: Stats
}

export const TODAY_KEY = ['today'] as const
export const fetchToday = () => api<Today>('GET', '/api/me/today')
export const useToday = () => useQuery({ queryKey: TODAY_KEY, queryFn: fetchToday })
